import {
	AgeCard,
	AgeConfirmButton,
	AgeOrbit,
	AgeRangeInput,
	AgeReadout,
	AgeScale,
	AgeStageSection,
} from '../studio.styles';

const AgeStage = ({ age, onAgeChange, onConfirm, labels }) => {
	const progress = `${((age - 18) / (70 - 18)) * 100}%`;

	return (
		<AgeStageSection data-studio-panel="age" aria-label={labels.chooseAge}>
			<AgeCard>
				<AgeOrbit aria-hidden="true" />
				<AgeReadout>
					<span>{labels.ageLabel}</span>
					<strong>{age}</strong>
				</AgeReadout>
				<AgeRangeInput
					type="range"
					min="18"
					max="70"
					value={age}
					style={{ '--age-progress': progress }}
					aria-label={labels.chooseAge}
					onChange={(event) => onAgeChange(Number(event.target.value))}
				/>
				<AgeScale aria-hidden="true">
					<span>18</span>
					<span>70</span>
				</AgeScale>
			</AgeCard>
			<AgeConfirmButton type="button" onClick={onConfirm}>
				{labels.confirmAge}
			</AgeConfirmButton>
		</AgeStageSection>
	);
};

export default AgeStage;
